import React from "react";
import BioMedicalWasteAnnualReportFormPage from "../components/bio-medical-waste/BioMedicalWasteAnnualReportFormPage";

const BioMedicalWasteAnnualReportCreate = () => (
  <BioMedicalWasteAnnualReportFormPage mode="create" />
);

export default BioMedicalWasteAnnualReportCreate;
